var Acr = Acr || {};

Acr.VerticalMultitab = function () {
  var $verticalMultitab;
  var $imgSliderSwiperContainer;
  var $textSliderSwiperContainer;
  var $swiperPagination;
  var $arrowLeft;
  var $arrowRight;
  var $verticalMultitabTabs;
  var $verticalMultitabImageSlides;
  var $tabsContainer;
  var $currentActiveTab;
  var $currentSlide;
  var $verticalMultitabTextContainer;
  var $verticalMultitabTextSlides;
  var $verticalMultitabHeading;
  var currentDataIndex;
  var currentSlideId;
  var matchMedia;
  var verticalMultitabCurrentTheme;
  var verticalMultitabCurrentHeadingTheme;
  var verticalMultitabImgSwiper;
  var verticalMultitabTextSwiper;
  const tabSelectorClass = '.js-vertical-multitab-tab-item';
  const imageSlideSelectorClass = '.js-vertical-multitab-image-slide';
  const swiperImgContainerSelector = '.js-img-swiper-container';
  const swiperTextContainerSelector = '.js-text-swiper-container';
  const swiperPaginationSelector = '.js-swiper-pagination';
  const arrowLeftSelector = '.js-arrow-left';
  const arrowRightSelector = '.js-arrow-right';
  const tabContentTabsContainer = '.js-vertical-multitab-tabs-container';
  const textContainerSelectorClass = '.js-vertical-multitab-text-container';
  const textSlideSelectorClass = '.js-vertical-multitab-text-slide';
  const headingSelectorClass = '.js-vertical-multitab-heading';
  const swiperSlideActive = '.swiper-slide-active';
  const tabActiveClass = 'acr-vertical-multitab__tab-item--active';
  const slideActiveClass = 'active-slide';
  const scrollAnimationsClass = 'scroll-animations';

  function initSelectors(element) {
    $verticalMultitab = element;
    $imgSliderSwiperContainer = $verticalMultitab.querySelector(swiperImgContainerSelector);
    $textSliderSwiperContainer = $verticalMultitab.querySelector(swiperTextContainerSelector);
    $swiperPagination = $verticalMultitab.querySelector(swiperPaginationSelector);
    $arrowLeft = $verticalMultitab.querySelector(arrowLeftSelector);
    $arrowRight = $verticalMultitab.querySelector(arrowRightSelector);
    $verticalMultitabTabs = $verticalMultitab.querySelectorAll(tabSelectorClass);
    $verticalMultitabImageSlides = $verticalMultitab.querySelectorAll(imageSlideSelectorClass);
    $verticalMultitabTextContainer = $verticalMultitab.querySelector(textContainerSelectorClass);
    $verticalMultitabTextSlides = $verticalMultitab.querySelectorAll(textSlideSelectorClass);
    $tabsContainer = $verticalMultitab.querySelector(tabContentTabsContainer);
    $verticalMultitabHeading = $verticalMultitab.querySelector(headingSelectorClass);
  }

  function bindEvents() {
    matchMedia.addListener(toggleVerticalSliderSwiper);
    // Attachment of click events for each of the tabs
    $verticalMultitabTabs.forEach(function (tab) {
      tab.addEventListener('click', tabClickHandler);
    });
  }

  // Function that is called when a tab is clicked
  function tabClickHandler() {
    var clickedTabId = this.getAttribute('tab-id');
    updateTabsStatus(clickedTabId);
    updateTheme(clickedTabId);
  }

  // Function that is called when an arrow is clicked
  function swipeSlideClickHandler() {
    var currentSlide = $verticalMultitab.querySelector(swiperSlideActive);
    var slideId = currentSlide.getAttribute('id');

    $verticalMultitabImageSlides.forEach(function (tabContent) {
      var tabContentId = tabContent.getAttribute('id');
      if (tabContentId === slideId) {
        tabContent.classList.add(slideActiveClass);
      } else {
        tabContent.classList.remove(slideActiveClass);
      }
    });

    $verticalMultitabTextSlides.forEach(function (tabText) {
      var tabTextId = tabText.getAttribute('data-id');
      if (tabTextId === slideId) {
        tabText.classList.add(slideActiveClass);
      } else {
        tabText.classList.remove(slideActiveClass);
      }
    });

    updateTheme(slideId);
    $currentActiveTab = $verticalMultitab.querySelector('.' + slideActiveClass);
    currentDataIndex = $currentActiveTab.getAttribute('data-index');
  }

  // Function to set a tab and its content as an "active" tab when a new tab is clicked.
  function updateTabsStatus(paramTargetTab) {
    $verticalMultitabTabs.forEach(function (tab) {
      var tabId = tab.getAttribute('tab-id');
      if (tabId === paramTargetTab) {
        tab.classList.add(tabActiveClass);
      } else {
        tab.classList.remove(tabActiveClass);
      }
    });

    $verticalMultitabImageSlides.forEach(function (tabContent) {
      var tabContentId = tabContent.getAttribute('id');
      if (tabContentId === paramTargetTab) {
        tabContent.classList.add(slideActiveClass);
      } else {
        tabContent.classList.remove(slideActiveClass);
      }
    });

    $verticalMultitabTextSlides.forEach(function (tabText) {
      var tabTextId = tabText.getAttribute('data-id');
      if (tabTextId === paramTargetTab) {
        tabText.classList.add(slideActiveClass);
      } else {
        tabText.classList.remove(slideActiveClass);
      }
    });

    $currentActiveTab = $verticalMultitab.querySelector('.' + slideActiveClass);
    currentDataIndex = $currentActiveTab.getAttribute('data-index');
  }

  // Function that is called to change the theme of the component
  function updateTheme(paramTargetTab) {
    var $verticalMultitabTab = $verticalMultitab.querySelector('#' + paramTargetTab);

    if (verticalMultitabCurrentTheme) {
      var dataTheme = $verticalMultitabTab.getAttribute('data-theme');
      $tabsContainer.classList.remove(verticalMultitabCurrentTheme);
      $tabsContainer.classList.add(dataTheme);
      verticalMultitabCurrentTheme = dataTheme;
    }
    if (verticalMultitabCurrentHeadingTheme) {
      var dataHeadingTheme = $verticalMultitabTab.getAttribute('data-heading-theme');
      $verticalMultitabHeading.classList.remove(verticalMultitabCurrentHeadingTheme);
      $verticalMultitabHeading.classList.add(dataHeadingTheme);
      verticalMultitabCurrentHeadingTheme = dataHeadingTheme;
    }
    var dataBgColor = $verticalMultitabTab.getAttribute('data-bg-color');
    setBackgroundColor(dataBgColor);
  }

  // Function that sets the current theme being used when the page loads
  function setInitialTheme() {
    var verticalMultitabCurrentBg = $currentActiveTab.getAttribute('data-bg-color');
    verticalMultitabCurrentTheme = $currentActiveTab.getAttribute('data-theme');
    verticalMultitabCurrentHeadingTheme = $currentActiveTab.getAttribute('data-heading-theme');

    if (verticalMultitabCurrentBg) {
      setBackgroundColor(verticalMultitabCurrentBg);
    }
    if (verticalMultitabCurrentTheme) {
      $tabsContainer.classList.add(verticalMultitabCurrentTheme);
    }
    if (verticalMultitabCurrentHeadingTheme) {
      $verticalMultitabHeading.classList.add(verticalMultitabCurrentHeadingTheme);
    }
  }

  // Function that sets the current background color of the component
  function setBackgroundColor(backgroundColor) {
    if (!Utility.isDesktop()) {
      $verticalMultitab.style.backgroundColor = backgroundColor;
    } else {
      $verticalMultitab.style.backgroundColor = 'transparent';
    }
  }

  // Function that enables or disables the Swiper Slider depending on screen size
  function toggleVerticalSliderSwiper() {
    var deleteInstance = false;
    var cleanStyles = true;

    if (matchMedia.matches) {
      $currentSlide = $verticalMultitab.querySelector(swiperSlideActive);
      if ($currentSlide) {
        currentSlideId = $currentSlide.getAttribute('id');
        verticalMultitabImgSwiper.destroy(deleteInstance, cleanStyles);
        verticalMultitabTextSwiper.destroy(deleteInstance, cleanStyles);
        updateTabsStatus(currentSlideId);
        updateTheme(currentSlideId);
      }
    } else {
      initVerticalSliderSwiper();
      verticalMultitabImgSwiper.slideToLoop(parseInt(currentDataIndex, 10));
      $currentSlide = $verticalMultitab.querySelector(swiperSlideActive);
      if ($currentSlide) {
        currentSlideId = $currentSlide.getAttribute('id');
        $verticalMultitab.style.backgroundImage = 'none';
        setInitialTheme();
      }
    }
  }

  // Initialize the swiper slider
  function initVerticalSliderSwiper() {
    // Create a swiper for the mobile images
    verticalMultitabImgSwiper = new Swiper($imgSliderSwiperContainer, {
      slidesPerView: 1,
      slidesPerColumn: 1,
      loop: true,
      pagination: {
        el: $swiperPagination,
        clickable: true,
      },
      navigation: {
        nextEl: $arrowRight,
        prevEl: $arrowLeft,
      },
      init: false,
      initialSlide: parseInt(currentDataIndex, 10),
      on: {
        slideChangeTransitionStart: function () {
          swipeSlideClickHandler();
        },
      },
    });

    // Create a swiper for the mobile text below the images
    verticalMultitabTextSwiper = new Swiper($textSliderSwiperContainer, {
      slidesPerView: 1,
      slidesPerColumn: 1,
      loop: true,
      init: false,
      initialSlide: parseInt(currentDataIndex, 10),
    });

    // Each of the swipers controlls the other
    verticalMultitabImgSwiper.controller.control = verticalMultitabTextSwiper;
    verticalMultitabTextSwiper.controller.control = verticalMultitabImgSwiper;

    if (!Utility.isDesktop()) {
      verticalMultitabImgSwiper.init();
      verticalMultitabTextSwiper.init();
    }

    verticalMultitabImgSwiper.on('slideChange', function () {
      if (Acr.TrackingManager) {
        Acr.TrackingManager.sendCarouselActivity(event.currentTarget, this);
      }
    });
  }

  function initObservers() {
    var observer = new IntersectionObserver(function (entries, observer) {
      if (entries[0].isIntersecting) {
        $verticalMultitabTextContainer.classList.add(scrollAnimationsClass);
      } else {
        $verticalMultitabTextContainer.classList.remove(scrollAnimationsClass);
      }
    });
    observer.observe($verticalMultitabTextContainer);
  }

  function initGlobalVariables() {
    $currentActiveTab = $verticalMultitab.querySelector('.' + slideActiveClass);
    if ($currentActiveTab) {
      currentDataIndex = $currentActiveTab.getAttribute('data-index');
      matchMedia = window.matchMedia('(min-width: ' + (Constants.breakpoints.lg) + 'px)');
    }
  }

  function init(element) {
    initSelectors(element);
    initGlobalVariables();
    if ($currentActiveTab) {
      initObservers();
      initVerticalSliderSwiper();
      setInitialTheme();
      bindEvents();
    }
  }

  return {
    init: init,
  };
};
